/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const MediaWrapper = styled.div.attrs((props) => ({
  style: { opacity: props.opacity },
}))`
  // position: sticky;
  top: 0;
  width: 100%;

  video {
    object-fit: cover;
    width: 100%;
    height: 410px;
    border-radius: 0.5rem;
  }
`;
